import { UserEntity } from '@okletsplay/core';
import { getAssetTransformerUrl } from './cdn-files';

export const getUserAvatarUrl = (user: Partial<UserEntity>, size = 10) => {
  if (user?.avatarKey) {
    return getAssetTransformerUrl(user?.avatarKey, {
      resize: {
        width: size,
        height: size,
      },
    });
  }

  const decodedUrl = decodeURIComponent(user?.image ?? '');

  if (!decodedUrl) return '';

  return decodedUrl + `&size=${size}&radius=50`;
};
